import { useState } from "react";
import { Modal, Typography, Button } from "antd";
import { useDispatch } from "react-redux";
import CustomTable from "../../components/CustomTable/CustomTable";
import CustomModal from "../../components/CustomModal/CustomModal";
import { FORM_MODAL_WIDTHS } from "../../constants/constants";
import { getDealInterestInvestors } from "../../redux/slices/DealApprovalSlice";
import MeetingEmailForm from "./MeetingEmailForm";

const { Paragraph } = Typography;

const FeedbackTable = ({ data, activeTab, dealId }) => {
  const dispatch = useDispatch();
  const [selectedFeedback, setSelectedFeedback] = useState("");
  const [selectedInvestor, setSelectedInvestor] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys, rows) => {
      setSelectedRowKeys(keys);
      setSelectedRows(rows);
    },
  };

  const enableSelection =
    activeTab === "Neutral" || activeTab === "Request more info";

  const feedbackColumns = [
    {
      title: "Investor Name",
      dataIndex: "investorName",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
    },
    {
      title: "Interest Status",
      dataIndex: "interestStatus",
    },
    ...((activeTab === "Neutral" || activeTab === "Request more info")
      ? [
          {
            title: "Email Sent",
            dataIndex: "isEmailSent",
            render: (isEmailSent) => (isEmailSent ? "Yes" : "No"),
          },
        ]
      : []),
    ...(activeTab === "Not Interested"
      ? [
          {
            title: "Feedback",
            dataIndex: "feedback",
            width: 120,
            render: (feedback) =>
              feedback ? (
                <Button
                  type="link"
                  style={{ padding: 0 }}
                  onClick={() => setSelectedFeedback(feedback)}
                >
                  View
                </Button>
              ) : (
                "-"
              ),
          },
        ]
      : []),
  ];

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <div />

        {enableSelection && (
          <Button
            type="primary"
            disabled={!selectedRowKeys.length}
            onClick={() => setSelectedInvestor(selectedRows)}
          >
            Send Meeting Email ({selectedRowKeys.length})
          </Button>
        )}
      </div>
      <CustomTable
        rowKey="orgId"
        columns={feedbackColumns}
        dataSource={data}
        rowSelection={enableSelection ? rowSelection : undefined}
      />

      <Modal
        title="Investor Feedback"
        open={!!selectedFeedback}
        onCancel={() => setSelectedFeedback("")}
        footer={null}
        centered
        width={600}
      >
        <Paragraph
          style={{
            whiteSpace: "pre-wrap",
            marginBottom: 0,
            lineHeight: 1.8,
          }}
        >
          {selectedFeedback}
        </Paragraph>
      </Modal>

      <CustomModal
        title="Send Meeting Invitation"
        open={!!selectedInvestor}
        centered
        width={FORM_MODAL_WIDTHS}
        content={
          <MeetingEmailForm
            investors={selectedInvestor}
            onClose={() => setSelectedInvestor(null)}
            dealId={dealId}
            activeTab={activeTab}
            onSuccess={() => {
              setSelectedInvestor(null);
              setSelectedRowKeys([]);
              setSelectedRows([]);
              dispatch(
                getDealInterestInvestors({
                  dealId,
                  interestStatus: activeTab,
                })
              );
            }}
          />
        }
      />
    </>
  );
};

export default FeedbackTable;
